import axios from 'axios';

// Bare axios — NO auth Bearer, NO refresh interceptor. Public no-login page.
const publicAxios = axios.create({ baseURL: '/api' });

export interface InvoiceDraftItem {
  name: string;
  qty: number;
  unit: string;
  unitPrice: number;
  lineTotal: number;
}

export interface InvoiceDraft {
  refNumber: number;
  vendorName: string;
  items: InvoiceDraftItem[];
  grandTotal: number;
  bankAccountName: string | null;
  bankAccountNumber: string | null;
  alreadyConfirmed: boolean;
}

export interface ConfirmPayload {
  idCardNumber: string;
  bankAccountName?: string;
  bankAccountNumber?: string;
  signatureBase64: string;
}

export interface SlipInfo {
  refNumber: number;
  paid: boolean;
  paidAt: string | null;
  hasSlip: boolean;
}

export const invoiceConfirmApi = {
  get: (token: string) =>
    publicAxios
      .get<InvoiceDraft>(`/public/invoice/${token}`)
      .then((r) => r.data),

  confirm: (token: string, payload: ConfirmPayload) =>
    publicAxios
      .post<{ ok: true }>(`/public/invoice/${token}/confirm`, payload)
      .then((r) => r.data),

  getSlipInfo: (token: string) =>
    publicAxios
      .get<SlipInfo>(`/public/invoice/${token}/slip-info`)
      .then((r) => r.data),

  // Absolute path (not through publicAxios) — meant for direct link/new-tab open.
  slipUrl: (token: string) => `/api/public/invoice/${token}/slip`,
};
